import $ from 'jquery';
import 'blueimp-file-upload'

document.addEventListener("turbolinks:load", function () {
  // Upload do documento direto para S3
  $('.directUpload').each(function(i, elem) {
    var fileInput    = $(elem);
    var url          = fileInput.data('url');
    var formData     = fileInput.data('form-data');
    var directId     = fileInput.data('direct-id');
    var directUploadPath = fileInput.data('direct-upload-path');
    var fileSelected = fileInput.data('file-selected');
    var uploadAreaMsg = fileInput.data('upload-area-msg');
    var fileError = fileInput.data('file-error');
    var fileLoading = fileInput.data('file-loading');
    var fileVerifying = fileInput.data('file-verifying');
    var maxFileSize = fileInput.data('max-file-size');
    var fileTooLarge = fileInput.data('file-too-large');
    var intervalId   = null;
    var uploadData   = null;

    const inputStyleSuccess = function(data) {
      var input = data.fileInputClone;
      var uploadArea = $('#upload-area');

      uploadArea.find('.upload-text-one').text(fileSelected + data.files[0].name);
      uploadArea.addClass('file-selected');
    }

    const showError = function(message) {
      $('#error-message').text(message);
      $('#error-section').show();
    }

    const hideError = function() {
      $('#error-section').hide();
    }

    const resetUploadArea = function() {
      var uploadArea = $('#upload-area');
      uploadArea.removeClass('file-selected');
      uploadArea.find('.upload-text-one').text(uploadAreaMsg);
      $('#file-key').val('');
      fileInput.val('');
    }

    const checkFinished = function() {
      $.ajax({
        url: directUploadPath,
        type: 'GET',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(res) {
          if (res.status == 'finished' || res.status == 'failed') {
            clearInterval(intervalId);
            if (res.success) {
              // Sucesso - volta para o formulário
              $('#loading-section').hide();
              $('.step-upload-container__form__title').show();
              $('#form-section').show();
              inputStyleSuccess(uploadData);
              $('#submit-btn').prop('disabled', false);
            } else {
              // Erro - volta para o formulário com erro
              $('#loading-section').hide();
              $('.step-upload-container__form__title').show();
              $('#form-section').show();
              resetUploadArea();
              $('#submit-btn').prop('disabled', true);
              showError(res.message || fileError);
            }
          }
        }
      })
    }

    fileInput.fileupload({
      fileInput:        fileInput,
      url:              url,
      type:            'POST',
      autoUpload:       true,
      formData:         formData,
      paramName:        'file',
      dataType:         'XML',
      replaceFileInput: true,
      add: function (e, data) {
        var file = data.files[0];

        if (file && maxFileSize && file.size > maxFileSize) {
          resetUploadArea();
          $('#submit-btn').prop('disabled', true);
          showError(fileTooLarge);
          return false;
        }

        hideError();
        data.submit();
      },
      start: function (e) {
        hideError();
        $('.step-upload-container__form__title').hide();
        $('#form-section').hide();
        $('#loading-section').show();
        $('#loading-message').text(fileLoading);
      },
      done: function(e, data) {
        var key   = $(data.jqXHR.responseXML).find("Key").text();

        $('#loading-message').text(fileVerifying);
        $('#file-key').val(key);
        
        $.ajax({
          url: directUploadPath,
          type: 'PUT',
          data: {key: key},
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
          },
          success: function() {
            intervalId = setInterval(checkFinished, 3000);
            uploadData = data
          },
          error: function(xhr) {
            $('#loading-section').hide();
            $('.step-upload-container__form__title').show();
            $('#form-section').show();
            resetUploadArea();
            $('#submit-btn').prop('disabled', true);
            showError(fileError);
          }
        })

        var input = $("<input />", { type:'hidden', name: 'ai_service[file_key]', value: key })
        fileInput.after(input);
      },
      fail: function(e, data) {
        $('#loading-section').hide();
        $('.step-upload-container__form__title').show();
        $('#form-section').show();
        resetUploadArea();
        $('#submit-btn').prop('disabled', true);
        showError(fileError);
      }
    });
  });

  if (!document.getElementById('ai-service-spinner-styles')) {
    var style = document.createElement('style');
    style.id = 'ai-service-spinner-styles';
    style.textContent = `
      .file-selected {
        border: 1px solid #724a88 !important;
        background-color: #bd169e33 !important;
      }
    `;
    document.head.appendChild(style);
  }
})
